import moment from 'moment';

export const toFullDateTimeDisplay = (dateTimeString?: string): string => {
  return dateTimeString
    ? moment.utc(dateTimeString).format('MMM D YYYY h:mm A')
    : '';
};
